import { render, staticRenderFns } from "./SelectionStyle.vue?vue&type=template&id=64db1d0e&"
import script from "./SelectionStyle.vue?vue&type=script&lang=js&"
export * from "./SelectionStyle.vue?vue&type=script&lang=js&"
import style0 from "./SelectionStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports